<template>
  <el-aside >
    <vs-sidebar right open style="border-radius: 0px">
      <!-- <SideHeader /> -->
      <button class="back" @click="show = !show">
        <div class="arrowIcon">
          <i class="fas fa-chevron-right"></i>
        </div>
        المستخدمين
      </button>
      <div class="fatura" v-if="!show">
        <!-- <span @click="goTo('/users/new-user')" v-if="accessLinks('add_employee')">
          <vs-sidebar-item :class="isActive('NewUser') ? 'active' : ''">
            اضافة مستخدم
          </vs-sidebar-item>
        </span> -->
        <span @click="goTo('/users/all-users')" v-if="accessLinks('list_employee')">
          <vs-sidebar-item :class="isActive('AllUsers') ? 'active' : ''">
            المستخدمين
          </vs-sidebar-item>
        </span>
        <span @click="goTo('/users/logs')" v-if="accessLinks('user_logs')">
          <vs-sidebar-item :class="isActive('UsersLogs') ? 'active' : ''">
            السجلات
          </vs-sidebar-item>
        </span>
        <!-- <span @click="goTo('/users/jobs')" v-if="accessLinks('list_role')">
          <vs-sidebar-item :class="isActive('UsersJobs') ? 'active' : ''">
            الصلاحيات والوظائف
          </vs-sidebar-item>
        </span> -->
      </div>
      <div class="content" v-if="show">
        <!-- <MainAside /> -->
      </div> </vs-sidebar
  ></el-aside>
</template>

<script>
// import SideHeader from "./SideHeader";
// import MainAside from "./MainAside";
export default {
  components: {
    // SideHeader,
    // MainAside,
  },
  name: "Home",
  data: () => ({
    active: "sales",
    ind: 0,
    show: false,
    activeSidebar: true,
  }),
  created() {
    // alert(this.$route.name);
  },
  methods: {
    isActive(routerName) {
      if (this.$route.name == routerName) {
        return true;
      } else {
        return false;
      }
    },
    goTo(routerName) {
      this.$router.push({ path: routerName });
    },
    logout() {
      this.$confirm("هل تريد تسجيل الخروج ؟", "تحذير", {
        confirmButtonText: "موافق",
        cancelButtonText: "رفض",
        type: "warning",
        center: true,
      })
        .then(() => {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          localStorage.removeItem("menu");
          localStorage.removeItem("permissionNames");
          this.goTo("/login");
          this.$message({
            type: "success",
            message: "تم تسجيل الخروج بنجاح",
          });
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: 'تم إلغاء'
          // });
        });
    },
    accessLinks(link) {
      let permissionNames = JSON.parse(localStorage.getItem("permissionNames"));
      return permissionNames.includes(link);
    },
  },
};
</script>
<style lang="sass" >
@import "../styles/aside.scss"
</style>
